import { SEND_EMAIL_REL } from './constants'

export const getRiskData = (state) => state.riskData
export const getPriceData = (state) => state.price

export const sendEmailSelector = (state) =>
  state.links.filter((link) => link.Rel === SEND_EMAIL_REL)[0]
